// src/lib/ExtendedWarrantyService.js
import API_CONFIG from "./ApiConfig";

const RefinanceService = {
  
  createFlow: async (token) => {
    const response = await fetch(
      `${API_CONFIG.BASE_URL}/api/refinancing/flow`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-user-token": token,
        },
        body: JSON.stringify({}),
      }
    );
    return await response.json();
  },

  getFlow: async (token) => {
    const response = await fetch(
      `${API_CONFIG.BASE_URL}/api/refinancing/flow`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "x-user-token": token,
        },
      }
    );
    return await response.json();
  },

  
};



export default RefinanceService;
